/**
 * @fileoverview PUT handler for the "/engagement/:app_group_id/library_edit" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdLibraryEditCacheKeys } from "./constants";
import type { PutEngagementAppGroupIdLibraryEditProps, EngagementAppGroupIdLibraryEditResult } from "./types";

export const putEngagementAppGroupIdLibraryEdit = reactQueryMutationAdapter(
  engagementAppGroupIdLibraryEditCacheKeys,
  (props: PutEngagementAppGroupIdLibraryEditProps): Promise<EngagementAppGroupIdLibraryEditResult> => {
    return fetch(`/engagement/${props.app_group_id}/library_edit`, "PUT", props);
  }
);
